import React from 'react'
import { Card, Row, Col } from "react-bootstrap"
import { useTranslation } from "react-i18next";
import { useState } from 'react';
import { ActionButton, IconButton, TooltipHost, TooltipOverflowMode, css, mergeStyleSets } from '@fluentui/react';
import SidePanelVariables from './SidePanelVariables';
import { addVariableDataserieToElement } from '../../../../../services/sKPI/dataserie.service';
import { TeachBubble } from '../../../../Templates/TeachBubble';
import { BoardElementConfigHelpTexts } from '../../../../../common/HelpPageText';
import { __MessageTypes } from '../../../../../common/Dictionaries';
import PropTypes from 'prop-types';
import { showMessage } from '../../../../../common/Helpers';
import MessageBox from '../../../../Common/Message/MessageBox';
import MainAppContext from '../../../../../MainAppContext';
import { useContext } from 'react';
import List from '../../../../Templates/List';
import ListPagination from '../../../../Templates/List/ListPagination';
import SidePanelRolesProfiles from './SidePanelRolesProfiles';
import './style-card.css'
import './style-color-picker.css'
import './style.css'
function BoardElementSelected(props) {
    const { t } = useTranslation();
    const contextSite = useContext(MainAppContext);

    //Parametros de entrada.
    const { 
        inputParam_EditMode = false,
        inputParam_ElementType = null,
        inputParam_ElementItem = null,

        inputParam_TextIsDataLang = false,
        inputParam_SelectedVariables = null,
        inputParam_Index = 0,

        inputParam_TglViewGridType = false,

        inputParam_ElementListBase = null,
        inputParam_SetBoardElementsBase = null,

        inputParam_ElementList = null,
        inputParam_SetElementList = null,

        inputParam_ElementListGrid = null,
        inputParam_SetBoardElementsGrid = null,
    } = props;
    
    const [isAddVariablePanelOpen, setAddVariablePanelOpen] = useState(false);
    const [isAddRolesPanelOpen, setAddRolesPanelOpen] = useState(false);
    const [elementIdSelected, setElementIdSelected] = useState(false);
    
    const [messageConfig, setMessageConfig] = useState({
        message : null,
        messageType : "",
        showMessage : false,
    });

    const onOpenAddVariablePanel = (elementId) => {
        setAddVariablePanelOpen(true)
        setElementIdSelected(elementId)
    };

    const onOpenAddRolesPanel = (elementId) => {
        setAddRolesPanelOpen(true)
        setElementIdSelected(elementId)
    };
    const onDeleteBoardElement = (flag) => {
        if (flag) {
            const value = inputParam_ElementItem.nVariables - 1;
    
            updateElementValue(inputParam_ElementItem.id, value, 'nVariables', inputParam_ElementList, inputParam_SetElementList);
            updateElementValue(inputParam_ElementItem.id, value, 'nVariables', inputParam_ElementListBase, inputParam_SetBoardElementsBase);
            
            showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))
        }
        else {
            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
        }
    };
    const onAddVariablesToElement = (e, id) => {

        let itemsToSave = [];

        inputParam_SelectedVariables.forEach(variable => {
            itemsToSave.push({
                id: 0,
                variableId: variable.id,
                elementId: inputParam_ElementItem.id,
                beginDate: null,
                endDate: null,
                contractual: false
            })
        });


        addVariableDataserieToElement(inputParam_ElementItem.id, itemsToSave).then((response) => {
            if (response.data.succeeded) {
                const value = inputParam_ElementItem.nVariables + inputParam_SelectedVariables.length;

                updateElementValue(inputParam_ElementItem.id, value, 'nVariables', inputParam_ElementList, inputParam_SetElementList);
                updateElementValue(inputParam_ElementItem.id, value, 'nVariables', inputParam_ElementListBase, inputParam_SetBoardElementsBase);
                showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))
            }
            else {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
            }
        }).catch(() => {
            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
        });
    };

    const updateElementValue = (id, newValue, propertyValueName, dataArray, setDataArray) => {
        dataArray.forEach(element => {
            if (element.id === id) {
                element[propertyValueName] =  newValue;
            }
        });

        setDataArray(dataArray);
    };
    const updateElementGridValue = (id, newValue, propertyValueName, dataArray, setDataArray) => {
        dataArray.data.forEach(element => {
            if (element.id === id) {
                element[propertyValueName] =  newValue;
            }
        });

        setDataArray(prevState => ({
            ...prevState,
            data: dataArray.data,
            fireUpdate: true
        }));
    };
    const onUpdateElementRoleCount = (value, item, gridSetterEnabled) => {
        if (!gridSetterEnabled) {
            updateElementValue(inputParam_ElementItem.id, value, 'nRoles', inputParam_ElementList, inputParam_SetElementList);
            updateElementValue(inputParam_ElementItem.id, value, 'nRoles', inputParam_ElementListBase, inputParam_SetBoardElementsBase);
        }
        else {
            updateElementGridValue(item.id, value, 'nRoles', inputParam_ElementListGrid, inputParam_SetBoardElementsGrid);
        }
    };

    const classNames = mergeStyleSets({
        overflow: {
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        },
        parent: {
          selectors: { '> *:last-child': { marginTop: 10 } },
        },
    });

    return (<>
                {
                    !inputParam_TglViewGridType &&
                    <Card style={{ fontSize: "13px", borderLeft: `20px solid ${inputParam_ElementItem.nVariables > 0 ? "#7FD7A7" : ""}` }}>
                        <Card.Header className="card-header-compact">
                            <Card.Title className="d-flex justify-content-between">
                            <TooltipHost
                                overflowMode={TooltipOverflowMode.Self}
                                hostClassName={css(classNames.overflow)}
                                content={ inputParam_TextIsDataLang ? t(inputParam_ElementItem.name) : `${inputParam_ElementItem.code} | ${inputParam_ElementItem.name}` }
                                onTooltipToggle={false}
                                styles={{
                                    root: { display: 'block' },
                                }}
                            >
                                <b>{ inputParam_TextIsDataLang ? t(inputParam_ElementItem.name) : `${inputParam_ElementItem.code} | ${inputParam_ElementItem.name}` }</b>
                            </TooltipHost>

                                
                                
                                {
                                    inputParam_EditMode && (contextSite.securityProps.isAdmin || contextSite.securityProps.isSAdmin) &&
                                    <TeachBubble
                                        inputParam_ButtonId={"btnHelpAddVariables" + inputParam_Index}
                                        inputParam_Text={ t(BoardElementConfigHelpTexts.addVariableDataserie)}
                                        inputParam_Title={t('data-lang-helptext-title')}
                                    />
                                }
                            </Card.Title>
                        </Card.Header>
                        <Card.Footer className='w-100' style={{padding: "0px", minHeight:"46px", borderBottom: "1px solid rgba(0, 0, 0, 0.125)"}}>
                            <>
                                {
                                    inputParam_EditMode && (contextSite.securityProps.isAdmin || contextSite.securityProps.isSAdmin) &&
                                        <div className='board-toolbar d-flex float-end'>
                                            <ActionButton disabled={!(inputParam_SelectedVariables && inputParam_SelectedVariables.length > 0)} iconProps={{ iconName: 'Add' }} onClick={ onAddVariablesToElement }>
                                                { t('data-lang-btn-addvariales') }
                                            </ActionButton>
                                        </div>
                                }
                            </>
                        </Card.Footer>
                        <Card.Body className="card-board p-2">
                            <Row>
                                <Col xl={6}>
                                    <Row>
                                        <Col xl={6} className='pt-2'>
                                            <h6>
                                                <b>
                                                    {t('data-lang-lbl-variables')}
                                                </b>
                                            </h6>
                                        </Col>
                                        <Col xl={6} className='text-end'>
                                            <h6>
                                                <b>
                                                    <ActionButton onClick={() => onOpenAddVariablePanel(inputParam_ElementItem.id)} iconProps={{ iconName: 'EntryView' }} allowDisabledFocus >{`${t('data-lang-lbl-view')} (${inputParam_ElementItem.nVariables ? inputParam_ElementItem.nVariables : 0})`}</ActionButton>
                                                </b>
                                            </h6>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col xl={6} className="border-start">
                                    <Row>
                                        <Col xl={6} className='pt-2'>
                                            <h6>
                                                <b>
                                                    {t('data-lang-lbl-roles')}
                                                </b>
                                            </h6>
                                        </Col>
                                        <Col xl={6} className='text-end'>
                                            <h6>
                                                <b>
                                                    <ActionButton onClick={() => onOpenAddRolesPanel(inputParam_ElementItem.id)} iconProps={{ iconName: 'EntryView' }} allowDisabledFocus >{`${t('data-lang-lbl-view')} (${inputParam_ElementItem.nRoles ? inputParam_ElementItem.nRoles : 0})`}</ActionButton>
                                                </b>
                                            </h6>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Card.Body>
                        <Card.Footer>
                            <MessageBox
                                inputParam_Message={ messageConfig.message }
                                inputParam_Display={ messageConfig.showMessage }
                                inputParam_MessageType={ messageConfig.messageType }
                                inputParam_SetterMessage={ setMessageConfig }
                            />
                        </Card.Footer>
                        {
                            inputParam_EditMode &&
                            <>
                            {
                                isAddVariablePanelOpen &&
                                <SidePanelVariables 
                                    inputParam_IsPanelOpen={isAddVariablePanelOpen}
                                    inputParam_SetterIsPanelOpen={setAddVariablePanelOpen}
                                    inputParam_ElementId={inputParam_ElementItem.id}
                                    inputParam_OnDeleteBoardElement={onDeleteBoardElement}
                                />
                            }
                            {
                                isAddRolesPanelOpen &&
                                <SidePanelRolesProfiles
                                    inputParam_EditMode={true}
                                    inputParam_ElementType={inputParam_ElementType}
                                    inputParam_IsPanelOpen={isAddRolesPanelOpen}
                                    inputParam_SetterIsPanelOpen={setAddRolesPanelOpen}
                                    inputParam_OnUpdateElementRoleCount={onUpdateElementRoleCount}
                                    inputParam_Element={inputParam_ElementItem}
                                    inputParam_GridSetterEnabled={false}
                                />
                            } 
                            </>
                        }
                    </Card>
                }
                {
                    inputParam_TglViewGridType &&
                    <>
                        <List
                            listLocalStoragePageSizeVariableName="elementConfigElementList"
                            className="listElementConfigElementList"
                            manipulateLocalData={ true }
                            data={ (inputParam_ElementListGrid !== null ? inputParam_ElementListGrid : []) }
                            setData={ inputParam_SetBoardElementsGrid }
                            isHeaderVisible={false}
                            showHeaders={false}
                            columns={ [
                                {  
                                    key: 'extension',
                                    name: t('data-lang-lbl-type'),
                                    fieldName: 'extension',
                                    minWidth: 200,
                                    maxWidth: 400,
                                    onRender:(item) => {
                                        return  <Row>
                                                    <Col><p>{`${item.code} | ${item.name}`}</p></Col>
                                                    <Col className="col-auto me-auto d-flex"><p>{t('data-lang-lbl-variables')}</p>: <ActionButton onClick={() => onOpenAddVariablePanel(item.id)} iconProps={{ iconName: 'EntryView' }} allowDisabledFocus >{`${t('data-lang-lbl-view')} (${item.nVariables ? item.nVariables : 0})`}</ActionButton></Col>
                                                    <Col className="col-auto me-auto d-flex"><p>{t('data-lang-lbl-roles')}</p>: <ActionButton onClick={() => onOpenAddRolesPanel(item.id)} iconProps={{ iconName: 'EntryView' }} allowDisabledFocus >{`${t('data-lang-lbl-view')} (${item.nRoles ? item.nRoles : 0})`}</ActionButton></Col>
                                                    <Col className="col-auto me-auto">
                                                        <IconButton title={ t('data-lang-btn-addvariales') } disabled={!(inputParam_SelectedVariables && inputParam_SelectedVariables.length > 0)} iconProps={{ iconName: 'Add' }} onClick={ onAddVariablesToElement } />
                                                    </Col>
                                                </Row>
                                    }
                                }
                            ] } />
                        <ListPagination
                            listLocalStoragePageSizeVariableName="elementConfigElementList"
                            data={ (inputParam_ElementListGrid !== null ? inputParam_ElementListGrid : []) }
                            setData={ inputParam_SetBoardElementsGrid } />
                        <MessageBox
                            inputParam_Message={ messageConfig.message }
                            inputParam_Display={ messageConfig.showMessage }
                            inputParam_MessageType={ messageConfig.messageType }
                            inputParam_SetterMessage={ setMessageConfig }
                        />
                        {
                            inputParam_EditMode &&
                            <>
                            {
                                isAddVariablePanelOpen &&
                                <SidePanelVariables 
                                    inputParam_IsPanelOpen={isAddVariablePanelOpen}
                                    inputParam_SetterIsPanelOpen={setAddVariablePanelOpen}
                                    inputParam_ElementId={elementIdSelected}
                                    inputParam_OnDeleteBoardElement={onDeleteBoardElement}
                                />
                            }
                            {
                                isAddRolesPanelOpen && inputParam_ElementListBase.find(x => x.id === elementIdSelected) !== undefined &&
                                <SidePanelRolesProfiles
                                    inputParam_EditMode={true}
                                    inputParam_ElementType={inputParam_ElementType}
                                    inputParam_IsPanelOpen={isAddRolesPanelOpen}
                                    inputParam_SetterIsPanelOpen={setAddRolesPanelOpen}
                                    inputParam_OnUpdateElementRoleCount={onUpdateElementRoleCount}
                                    inputParam_Element={inputParam_ElementListBase.find(x => x.id === elementIdSelected)}
                                    inputParam_GridSetterEnabled={true}
                                />
                            }
                            </>
                        }
                    </>
                }
                
            </>
    );
}

BoardElementSelected.propTypes = {
    inputParam_EditMode: PropTypes.bool.isRequired,
    inputParam_ElementType: PropTypes.number,
    inputParam_ElementItem: PropTypes.object.isRequired,
    inputParam_ElementList: PropTypes.array,
    inputParam_ElementListBase: PropTypes.array,
    inputParam_TextIsDataLang: PropTypes.bool,
    inputParam_SelectedVariables: PropTypes.array,
    inputParam_SetBoardElementsBase: PropTypes.func.isRequired,
    inputParam_Index: PropTypes.number.isRequired,


    inputParam_TglViewGridType: PropTypes.bool,
    inputParam_ElementListGrid: PropTypes.object,
    inputParam_SetBoardElementsGrid: PropTypes.func,
};

export default BoardElementSelected;